<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      ref="editForm"
      :rules="rules"
    >
      <el-row>
        <el-form-item label="票面金额（万）" prop="faceValue">
          <el-input-number
            :min="0"
            size="small"
            :controls="false"
            v-model="editForm.faceValue"
            disabled
            placeholder="票面金额（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应收（万）" prop="outReceivable">
          <el-input-number
            :min="0"
            size="small"
            :controls="false"
            v-model="editForm.outReceivable"
            placeholder="应收（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应付（万）" prop="outPayable">
          <el-input-number
            :min="0"
            size="small"
            :controls="false"
            v-model="editForm.outPayable"
            placeholder="应付（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { waitpayForDeliverTicket } from "@/api/ticket/ticket";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rules: {
        outReceivable: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("金额不能为空"));
              } else {
                if (parseFloat(this.editForm.faceValue) <= value) {
                  callback(new Error("不能大于票面金额"));
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        outPayable: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("金额不能为空"));
              } else {
                if (parseFloat(this.editForm.faceValue) <= value) {
                  callback(new Error("不能大于票面金额"));
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 编辑、增加页面保存方法
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          waitpayForDeliverTicket(this.editForm)
            .then(() => {
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.error);
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("update:editForm", {});
      this.$refs.editForm.resetFields();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-estimate/add-edit/payment.vue